mutation DeleteUserUploadedMaterial($input: DeleteUserUploadedMaterialInput!) {
  deleteUserUploadedMaterial(input: $input) {
    success
    materialId
    error
  }
}
